import React from 'react';
import styled from 'styled-components';
import OfferIconSvg from '../assets/hotels/details/offer.svg';
import {defaultTheme} from 'build-theme/src/build-theme';

const OfferIcon = styled(OfferIconSvg as React.SFC<React.SVGProps<SVGSVGElement>>)`
  width: ${props => props.width || '1.2rem'};
  height: ${props => props.height || '1.2rem'};
  fill: ${props => props.fill || defaultTheme.colors.yellow.base};
  margin: ${props => props.margin};
  cursor: pointer;
`;

export default OfferIcon;
